export function slugify(text) {
  return text
    ? text
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Quitar acentos
        .replace(/\s+/g, "-") // Espacios por guion
        .replace(/[^\w\-]+/g, "") // Quitar caracteres raros
        .replace(/\-\-+/g, "-") // Multiples guiones por uno
        .trim()
    : "";
}

export const adapterMenu = (result) => {
  const flatMenu = result;
  const menuMap = new Map();

  flatMenu.forEach((row) => {
    // Nivel 1
    if (!menuMap.has(row.n1)) {
      menuMap.set(row.n1, {
        id: row.n1,
        title: row.n1_Nombre,
        slug: slugify(row.n1_Nombre),
        subitems: [],
        nivel: `${row.n1}/${0}/${0}`,// IDs de nivel 1, 2 y 3
      });
    }

    const nivel1 = menuMap.get(row.n1);

    // Nivel 2
    if (row.n2 && !nivel1.subitems.find((item) => item.id === row.n2)) {
      nivel1.subitems.push({
        id: row.n2,
        title: row.n2_Nombre,
        slug: `${nivel1.slug}/${slugify(row.n2_Nombre)}`,
        subitems: [],
        nivel: `${row.n1}/${row.n2}/${row.n3||0}`, // IDs de nivel 1, 2 y 3
      });
    }

    const nivel2 = nivel1.subitems.find((item) => item.id === row.n2);

    // Nivel 3
    if (row.n3 && nivel2 && !nivel2.subitems.find((item) => item.id === row.n3)) {
      nivel2.subitems.push({
        id: row.n3,
        title: row.n3_Nombre,
        slug: `${nivel2.slug}/${slugify(row.n3_Nombre)}`,
        nivel: `${row.n1}/${row.n2}/${row.n3}`, // IDs de nivel 1, 2 y 3
      });
    }
  });

  return Array.from(menuMap.values());
};
